import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { JobPreferencesDataRequest, RedeployMePersonResponse } from '../../typings';

@Injectable({ providedIn: 'root' })
export class JobPreferencesApiService {
  constructor(private apiService: ApiService) {}

  submitMoatsWithResume(request: JobPreferencesDataRequest, file: File): Observable<JobPreferencesDataRequest> {
    const formData = new FormData();
    formData.append('jsonData', JSON.stringify(request));
    formData.append('resumeFile', file);
    return this.apiService.httpWrapper<JobPreferencesDataRequest>({
      method: 'POST',
      url: `/api/job-preferences/file`,
      body: formData,
      authenticated: true
    });
  }

  submitMoats(request: JobPreferencesDataRequest): Observable<JobPreferencesDataRequest> {
    return this.apiService.httpWrapper<JobPreferencesDataRequest>({
      method: 'POST',
      url: `/api/job-preferences/`,
      body: JSON.stringify(request),
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json'
      })
    });
  }

  submitMoatsLooksGood(personId: number): Observable<boolean> {
    return this.apiService.httpWrapper<boolean>({
      method: 'POST',
      url: `/api/job-preferences/looksGood`,
      params: new HttpParams().set('personId', String(personId)),
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json'
      })
    });
  }

  getPersonIdByUuid(uuid: string): Observable<number> {
    const params = new HttpParams();
    return this.apiService.httpWrapper<number>({
      method: 'GET',
      url: `/api/job-preferences/person/${uuid}`,
      authenticated: true,
      params
    });
  }

  getPersonInfoByUuidRedeployme(uuid: string): Observable<RedeployMePersonResponse> {
    const params = new HttpParams();
    return this.apiService.httpWrapper<RedeployMePersonResponse>({
      method: 'GET',
      url: `/api/job-preferences/person/${uuid}/redeployme`,
      authenticated: true,
      params
    });
  }

  getCurrentJobPrefsData(personId: number): Observable<JobPreferencesDataRequest> {
    const params = new HttpParams();
    return this.apiService.httpWrapper<JobPreferencesDataRequest>({
      method: 'GET',
      url: `/api/job-preferences/${personId}`,
      authenticated: true,
      params
    });
  }

  getLastUpdatedTime(personId: number): Observable<Date> {
    const params = new HttpParams();
    return this.apiService.httpWrapper<Date>({
      method: 'GET',
      url: `/api/job-preferences/${personId}/lastUpdated`,
      authenticated: true,
      params
    });
  }
}
